export default "https://kr-a.kakaopagecdn.com/web/qa/5.3.1/static/v4/search/icon-search-light-6439148f9648bc415f7eb426e739453e.svg";